import React from 'react';
import Pill from '.';
const PillGroup = ({ pills }) => {
  return (
    <div className="pill-group">
      {pills.map(pill => (
        <Pill key={pill.itemKey} itemKey={pill.itemKey} text={pill.text} tooltipText={pill.tooltipText} />
      ))}
    </div>
  );
};

export default PillGroup;
